/*
 * @Author: DQL
 * @Date: 2020-03-05 17:12:35
 * @LastEditors: Wot
 * @LastEditTime: 2022-04-22 17:31:32
 * @Description: file content
 */
import Vue from 'vue';
import VueRouter from 'vue-router';

import { HMStoreService } from 'kestrel-core-ui';

import store from './store';
import config from './config';
import { getSubject, systemPreloadInfo } from '@/features/feature.common.service.js';

import layout from '@/layout.vue';

/* =============================================
   业务功能路由配置文件引入 Start
  *
  *
*/

// 系统管理
import systemRoutes from '@/features/system/system.routes.js';

// 工作流
import workflowRoutes from '@/features/workflow/workflow.routes.js';

// 用户中心
import userCenterRoutes from '@/features/userCenter/userCenter.routes.js';

// 考勤系统
import attendanceRoutes from '@/features/attendance/attendance.routes.js';

// 功能首页
import mainRoutes from '@/features/main/main.routes.js';

/* 业务功能路由配置文件引入 End */

/* =============================================
   业务功能路由配置写入 Start
  *
  *
*/

const FEATURES_ROUTES = [
  systemRoutes,
  workflowRoutes,
  userCenterRoutes,
  attendanceRoutes,
  mainRoutes
];

/* 业务功能路由配置写入 End */

/* =============================================
   首页路由配置start
  *
  *
*/

const home = { template: '<div>home首页</div>' };
// 系统首页路由
// const HOME_ROUTER_PATH = '/workflow/workflowIndex';
const HOME_ROUTER_PATH = '/main';

/* 首页路由配置end */

Vue.use(VueRouter);

/* 重写VueRouter的push方法，解决由于版本问题出现的控制台错误输出
   [NavigationDuplicated {_name: "NavigationDuplicated", name: "NavigationDuplicated"}]
   Vue-router在3.1之后把$router.push()方法改为了Promise。所以假如没有回调函数，错误信息就会交给全局的路由错误处理，因此就会报上述的错误。
*/
const routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error);
};

const routes = [
  {
    path: '/entrance',
    name: 'entrance',
    component: () => import(/* webpackChunkName: "entrance" */ '@/features/entrance/entrance.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/features/login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '@/features/register/register.vue')
  },
  {
    path: '/register/activate',
    name: 'registerActivate',
    component: () => import(/* webpackChunkName: "registerActivate" */ '@/features/register/activate.vue')
  },
  {
    path: '/forgetPassword',
    name: 'forgetPassword',
    component: () => import(/* webpackChunkName: "forgetPassword" */ '@/features/forgetPassword/forgetPassword.vue')
  },
  {
    path: '/resetPwd',
    name: 'resetPwd',
    component: () => import(/* webpackChunkName: "resetPwd" */ '@/features/forgetPassword/resetPwd.vue')
  },
  {
    path: '/email/activate',
    name: 'emailActivate',
    component: () => import(/* webpackChunkName: "emailActivate" */ '@/features/userCenter/emailActivate.vue')
  },
  {
    path: '/switchSubject',
    name: 'switchSubject',
    component: () => import(/* webpackChunkName: "switchSubject" */ '@/features/switchSubject/switchSubject.vue'),
    beforeEnter: (to, from, next) => {
      // 预加载用户信息
      getSubject()
        .then(rsp => {
          const userinfo = rsp.data;
          HMStoreService.updateUserinfo(userinfo);
          HMStoreService.updateMenu(userinfo.menuTree);
          next();
        });
    }
  },
  {
    path: '/',
    component: layout,
    redirect: HOME_ROUTER_PATH,
    beforeEnter: (to, from, next) => {
      // 进入根目录前检查是否登录
      const token = window.CookieUtil.get(config.localTokenName) || false;

      /*  next();
      return; */

      if (token) {
        systemPreloadInfo()
          .then(rsp => {
            /* 用户信息处理 Start */

            const userinfo = rsp[0].data;
            HMStoreService.updateUserinfo(userinfo);

            /* 用户信息处理 End */

            /* 基础枚举 Start */

            const enums = rsp[1].data;
            HMStoreService.updateEnums(enums);

            /* 基础枚举 End */

            /* 页面元素 Start */

            const menuElement = rsp[2].data;
            HMStoreService.updateMenuElement(menuElement);

            /* 页面元素 End */

            /* 菜单 Start */

            const menuTree = rsp[3].data || [];
            HMStoreService.updateMenu(menuTree);

            /* 菜单 End */

            /* 业务枚举 Start 依据需要配置 */

            const apiEnums = [
              { name: 'kqxtApi', data: rsp[4].data }
            ];
            store.commit('UPDATE_ENUMS', apiEnums);

            /* 业务枚举 End */
            next();
          });
      } else {
        next('/login');
      }
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: home,
        meta: {
          navtabTitle: '首页',
          isCache: true,
          ignoreDiff: [],
          isIframe: false
        }
      },
      // iframe页面路由
      {
        path: 'iframePage',
        name: 'iframePage',
        component: { template: '<div></div>' },
        meta: {
          isCache: true,
          isIframe: true
        }
      },
      ...FEATURES_ROUTES
    ]
  }
];

const router = new VueRouter({
  routes
});

export default router;
